import React from 'react'
import './covid.css'

function Covid() {
  return (
    <div className="container-fluid" id="covid">
    <div className="container col-xxl-8 px-4 py-5" >
    <div className="row flex-lg-row-reverse align-items-center g-5 py-5 blur-covid">
      <div className="col-lg-12">
        <h2 className="display-5 fw-bold lh-1 mb-3 about_heading text-white fw-bolder">Covid-19 Actions & Preparation</h2>
        <p className="lead">At Bethesda Home Care Services, We comply with AHS public health guidelines to ensure our clients' 
        and caregivers' safety during the COVID-19 Pandemic.
</p>
      </div>
    </div>
  </div>
  </div>
  )
}

export default Covid